var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirclePinGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Vector",
    cx: 12,
    cy: 12,
    r: 10,
    fill: "url(#paint0_linear_379_3667)",
    stroke: "white",
    strokeOpacity: 0.7,
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_379_3667",
    x1: 2,
    y1: 12,
    x2: 22,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8E063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DC913"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePinGreen);
export default __webpack_public_path__ + "static/media/circle-pin-green.514de6f390da8442bf12047592fabcb7.svg";
export { ForwardRef as ReactComponent };